/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React from 'react'
import ToggleActionLinkButton from '@/components/buttons/ToggleActionLinkButton'
import { Link } from 'react-router-dom'
import { Tag, Tbody, Td, Tr } from '@chakra-ui/react'

const TableBody = ({ table, getItemProps }) => {
  const rows = table.getRowModel().rows.map(row => {
    const currentItem = getItemProps ? getItemProps(row.original) : {}
    const buttonAction = currentItem.url
      ? { to: currentItem.url, as: Link }
      : currentItem.onAction
        ? { type: 'button', onClick: currentItem.onAction }
        : {}
    return (
      <Tr key={row.id}>
        { row.getVisibleCells().map(cell => {
          const columnId = cell.column.id
          let currentClass = ''
          let value = currentItem[columnId]
          if (cell.column.id === 'icon') {
            currentClass = '!p-0 !text-center'
            value = <img
              alt={currentItem.fileType}
              className="!h-7"
              src={ currentItem.iconUrl }
            />
          } else if (cell.column.id === 'listed') {
            const isListed = Boolean(currentItem[columnId])
            const listedLabel = isListed
              ? 'LISTED'
              : 'UNLISTED'
            const colorTag = isListed
              ? 'green'
              : 'red'

            value = <Tag colorScheme={colorTag}>{ listedLabel }</Tag>
          } else if (cell.column.id === 'actions') {
            currentClass = '!p-0 !text-center'
            value = <ToggleActionLinkButton
              {...buttonAction}
              label={currentItem.buttonLabel}
            />
          }

          return (
            <Td className={currentClass} key={cell.id}>{ value }</Td>
          )
        })}
      </Tr>
    )
  })

  return <Tbody>{ rows }</Tbody>
}

export default TableBody
